module.exports = __webpack_public_path__ + "img/horizontal_4_4_4.0821905a.png";